module.exports = __webpack_public_path__ + "assets/img/vtuber-zs.d837fa58.png";